import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 迁移任务列表
export const setMigrateTasks: Mutation<IModuleState> = (state, payload) => {
  state.taskList.data = payload.data;
  state.taskList.loading = !!payload.loading;
};

// 静态材质列表
export const setTextures: Mutation<IModuleState> = (state, payload) => {
  state.textureList.raw = payload.raw || state.textureList.raw;
  state.textureList.data = payload.data;
  state.textureList.loading = !!payload.loading;
};

// 灯光配置列表
export const setIesList: Mutation<IModuleState> = (state, payload) => {
  state.iesList.raw = payload.raw || state.iesList.raw;
  state.iesList.data = payload.data;
  state.iesList.loading = !!payload.loading;
};

// 迁移任务详情(子列表)
export const setTaskDetail: Mutation<IModuleState> = (state, payload) => {
  state.taskDetail.data = payload.data;
  state.taskDetail.loading = !!payload.loading;
};

// 迁移任务详情(子列表)里提取的物品或材料列表
export const setMatList: Mutation<IModuleState> = (state, payload) => {
  state.matList.data = payload.data;
  state.matList.loading = !!payload.loading;
};

// 品牌检查列表(与当前环境里品牌编码不一致的品牌列表)
export const setCheckList: Mutation<IModuleState> = (state, payload) => {
  state.checkList.data = payload.data;
  state.checkList.completed = !!payload.completed;
  state.checkList.loading = !!payload.loading;
  state.checkList.requiresDesignMigration = !!payload.requiresDesignMigration;
  state.checkList.canSkipDesignMigration = !!payload.canSkipDesignMigration;
  state.checkList.missingBrandCount = payload.missingBrandCount || 0;
};

// 迁移任务的运行状态
export const setTaskCheck: Mutation<IModuleState> = (state, payload) => {
  state.taskCheck.uuid = payload.uuid;
  state.taskCheck.result = !!payload.result;
  state.taskCheck.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
